<ng-container [ngSwitch]="firmwareUpdateStore.step$ | async">
  <app-firmware-update-start
    *ngSwitchCase="FirmwareUpdateStep.START"
    (cancel)="onCancel()"
  ></app-firmware-update-start>
  <app-firmware-update-verification
    *ngSwitchCase="FirmwareUpdateStep.VERIFICATION"
    (cancel)="onCancel()"
  >
  </app-firmware-update-verification>
  <app-firmware-update-one-time-approval
    *ngSwitchCase="FirmwareUpdateStep.ONE_TIME_APPROVAL"
    (cancel)="onCancel()"
  >
  </app-firmware-update-one-time-approval>
  <app-firmware-update-progress
    *ngSwitchCase="FirmwareUpdateStep.LOADING"
    [gatewaySerial]="data.gatewaySerial"
    (cancel)="onCancel()"
  >
  </app-firmware-update-progress>
  <app-firmware-update-up-to-date
    *ngSwitchCase="FirmwareUpdateStep.UP_TO_DATE"
    (cancel)="onCancel()"
  ></app-firmware-update-up-to-date>
  <app-firmware-update-version-list
    *ngSwitchCase="FirmwareUpdateStep.PREPARATION"
    [gatewaySerial]="data.gatewaySerial"
    (cancel)="onCancel()"
  >
  </app-firmware-update-version-list>
</ng-container>
